// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\DispatchEvent\ApiDispatchEvent.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { ApprovalOfCharges, ApprovalOfChargesData, ApprovalOfChargesOptions } from 'data/models/ApprovalOfCharges';
import { BillCoverage, BillCoverageData, BillCoverageOptions } from 'data/models/BillCoverage';
import { PilotAgency, PilotAgencyData, PilotAgencyOptions } from 'data/models/PilotAgency';
import { QuickBooksJobTracking, QuickBooksJobTrackingData, QuickBooksJobTrackingOptions } from 'data/models/QuickBooksJobTracking';

// DispatchEventData is the class that DispatchEvent serializes to/from
export interface DispatchEventData {
    Id : number;
    Url : string | null;
	
    _approvalsOfCharges : ApprovalOfChargesData[] | null;
    Bills : BillCoverageData[] | null;
    PilotAgency : PilotAgencyData | null;
    PilotAgencyId : number;
	
    Billable : boolean;
    Description : string;
    QBTracking : QuickBooksJobTrackingData;
    Start : /* ISO8601 */ string;
}

// DispatchEventOptions is the class which may be passed to the DispatchEvent constructor to define optional initial data values
export interface DispatchEventOptions {
    Id : number;
    Url? : string | null;
	
    _approvalsOfCharges? : ApprovalOfChargesOptions[] | null;
    Bills? : BillCoverageOptions[] | null;
    PilotAgency? : PilotAgencyOptions | null;
    PilotAgencyId? : number;
	
    Billable? : boolean;
    Description? : string;
    QBTracking? : QuickBooksJobTrackingOptions;
    Start? : /* ISO8601 */ string;
}

export class DispatchEvent {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public _approvalsOfCharges : SDataArray<ApprovalOfCharges>;
    public Bills : SDataArray<BillCoverage>;
    public PilotAgency : DataSignal<PilotAgency | null>;
    public PilotAgencyId : DataSignal<number>;
	
    public Billable : DataSignal<boolean>;
    public Description : DataSignal<string>;
    public QBTracking : QuickBooksJobTracking;
    public Start : DataSignal<TZDate>;

    constructor();
    constructor(data : DispatchEventOptions);
    constructor(data: DispatchEventOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this._approvalsOfCharges = SArray<ApprovalOfCharges>([]);
        this.Bills = SArray<BillCoverage>([]);
        this.PilotAgency = S.value<PilotAgency | null>(null);
        this.PilotAgencyId = jsonableObservable(S.value<number>(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
	    
        this.Billable = jsonableObservable(S.value<boolean>(data && data.Billable !== undefined ? data.Billable : false));
        this.Description = jsonableObservable(S.value<string>(data && data.Description !== undefined ? data.Description : ''));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking();
        this.Start = jsonableObservable(S.value<TZDate>(data && data.Start !== undefined ? new TZDate(data.Start) : new TZDate(0), TZDate.eq));
    }

    static key(obj : DispatchEvent) {
        return obj.Id();
    }
    
    static dataKey(obj : DispatchEventOptions) {
        return obj.Id;
    }

    static update(obj : DispatchEvent, data : DispatchEventOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.PilotAgencyId !== undefined) obj.PilotAgencyId(data.PilotAgencyId);
	        
            if (data.Billable !== undefined) obj.Billable(data.Billable);
            if (data.Description !== undefined) obj.Description(data.Description);
            if (data.QBTracking !== undefined) QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
            if (data.Start !== undefined) obj.Start(new TZDate(data.Start));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/DispatchEvent.ts